import { Outlet } from "react-router-dom";
import Header from "../../../components/header/Header";
import TeamLeaderSidebar from "../../sidebar/teamLeaderSidebar/TeamLeaderSidebar"

export function TeamLeaderLayout() {
  return (
    <div>
      <Header title="Wisdom Dashboard" />
      <div className="layout-container">
        <TeamLeaderSidebar />
        <div className="layout-outlet">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
